import { css } from "lit";

export const reportTabStyles = css`
  @import url("/src/styles/tokens.css");

  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  henry-panel {
    flex: 1;
    min-height: 0;
  }

  .tab-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
  }

  .tab-scroll {
    flex: 1;
    min-height: 0;
    min-width: 0;
    overflow: auto;
  }

  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-4);
    flex-wrap: wrap;
  }

  .filters {
    padding: var(--space-4);
    background: var(--color-broken-white);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-base);
    box-shadow: var(--shadow-sm);
    margin: var(--space-4) 0 var(--space-3);
    --henry-input-font-size: var(--font-size-sm);
    --henry-select-font-size: var(--font-size-sm);
  }

  .filters-bar {
    display: flex;
    align-items: end;
    gap: var(--space-3);
    flex-wrap: wrap;
  }

  .filters-bar henry-input.search {
    flex: 1 1 360px;
    min-width: 260px;
  }

  .filters-bar henry-select {
    flex: 0 0 160px;
    min-width: 140px;
  }

  .filters-actions {
    display: flex;
    align-items: end;
    gap: var(--space-2);
    flex: 0 0 auto;
    padding-bottom: 0; /* Removed padding to align with inputs */
  }

  .save-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid var(--color-primary-600);
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .filters-advanced {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: var(--space-3) var(--space-4);
    margin-top: var(--space-3);
    padding-top: var(--space-3);
    border-top: 1px solid var(--color-border);
    align-items: end;
  }

  .filters henry-select,
  .filters henry-input {
    margin-bottom: 0;
  }

  henry-table {
    margin-top: 0;
    --henry-table-sort-indicator-gap: var(--space-1);
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
